<script lang="ts">
import { defineAsyncComponent, defineComponent, provide } from 'vue';
// pspdfkit is defined as a static asset in our vite config
// this import will return the url where it can be laoded from in dev/prod environments
import PSPDFKitUrl from 'pspdfkit/dist/pspdfkit?url';
import { providePSPDFKit } from './PdfViewer';

/**
 * The PSPDFKit library is quite large and we load it as a static asset.
 * In order to have it available when the PdfViewer is created, this component manages the import resolution of both efficiently.
 *
 * The PSPDFKit library is then provided for all descendants of this component.
 */
export default defineAsyncComponent(() =>
    Promise.all([
        import('./PdfViewer.vue'),
        import(/* @vite-ignore */ PSPDFKitUrl),
    ]).then(([PdfViewer]) =>
        defineComponent({
            name: 'PdfViewerLoader',
            components: {
                PdfViewer: PdfViewer.default,
            },
            setup() {
                // @ts-ignore it does not make sense to provide the types if we don't need them
                provide(providePSPDFKit, window.PSPDFKit);
                // remove the global reference so it cannot be easily exploited
                // @ts-ignore same as above
                window.PSPDFKit = undefined;
            },
            methods: {
                /**
                 * @public
                 * Call a method on the viewer
                 */
                call(method: string, ...args: unknown[]) {
                    // @ts-ignore cannot resolve ref
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    return this.$refs.viewer[method](...args);
                },
            },
            template: '<PdfViewer ref="viewer" />',
        }),
    ),
);
</script>
